<div class="topbar">
  <h1>Fejl dashboard</h1>
</div>
<div class="dashboard">
  @if (antalFejl > 0) {
    <h2 class="red icon-with-text">
      <mat-icon svgIcon="alert-solid" class="mat-icon--red icon-48"></mat-icon>
      {{ antalFejl }} fejl i alt
    </h2>
  } @else {
    <h2>Ingen fejl</h2>
  }
  <div class="dashboard-tile-wrapper">
    <app-fejl-dashboard-knap
      [summary]="createEftersynHaltedSummary"
      (showlist)="showlist($event)"
      [loader]="createEftersynHaltedLoader"
    ></app-fejl-dashboard-knap>

    <app-fejl-dashboard-knap
      [summary]="customerOpkraevningHaltedSummary"
      (showlist)="showlist($event)"
      [loader]="customerOpkraevningHaltedLoader"
    ></app-fejl-dashboard-knap>

    <app-fejl-dashboard-knap
      [summary]="fejletDannelseAfEftersynFlereEftersynSummary"
      (showlist)="showlist($event)"
      [loader]="fejletDannelseAfEftersynFlereEftersynLoader"
    ></app-fejl-dashboard-knap>

    <app-fejl-dashboard-knap
      [summary]="fejletDannelseAfEftersynKreditstopSummary"
      (showlist)="showlist($event)"
      [loader]="fejletDannelseAfEftersynKreditstopLoader"
    ></app-fejl-dashboard-knap>

    <app-fejl-dashboard-knap
      [summary]="fejletOrdreAfregningSummary"
      (showlist)="showlist($event)"
      [loader]="fejletOrdreAfregningLoader"
    ></app-fejl-dashboard-knap>
    <app-fejl-dashboard-knap
      [summary]="fejletOverfoerselSummary"
      (showlist)="showlist($event)"
      [loader]="fejletOverfoerselLoader"
    ></app-fejl-dashboard-knap>
    <app-fejl-dashboard-knap
      [summary]="serviceintervallerSummary"
      (showlist)="showlist($event)"
      [loader]="serviceintervallerLoader"
    ></app-fejl-dashboard-knap>
    <app-fejl-dashboard-knap
      [summary]="slutopgoerelserHaltedSummary"
      (showlist)="showlist($event)"
      [loader]="slutopgoerelserHaltedLoader"
    ></app-fejl-dashboard-knap>
    <app-fejl-dashboard-knap
      [summary]="postnummerUdenPartnerSummary"
      (showlist)="showlist($event)"
      [loader]="postnummerUdenPartnerLoader"
    ></app-fejl-dashboard-knap>
    <app-fejl-dashboard-knap
      [summary]="afregningerHaltedSummary"
      (showlist)="showlist($event)"
      [loader]="afregningerHaltedLoader"
    ></app-fejl-dashboard-knap>
  </div>
</div>
@if (dataSource) {
  <div class="dashboard__list">
    @if (showStateChanged) {
      <div class="overlay">
        <mat-progress-spinner class="spinner" [color]="'primary'" [mode]="'indeterminate'"></mat-progress-spinner>
      </div>
    }
    @if (!loadStateChanged) {
      <div>
        @if (dataSource.data) {
          <div>
            <small>
              Viser {{ dataSource.data.length }}
              <span>af {{ activeSummaryAntalFejl }}</span>
            </small>
          </div>
        }
        @if (currentFejlDashboardType == 'PostnummerUdenPartner') {
          <div>
            <table mat-table matSort [dataSource]="dataSource" (matSortChange)="sortData($event)" class="mat-elevation-z0">
              <ng-container matColumnDef="partnerServiceProdukt">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
                <td mat-cell *matCellDef="let row">
                  @if (row.partnerServiceProdukt.toLowerCase() != 'gasstorbraender') {
                    <div>
                      <mat-icon [svgIcon]="row.partnerServiceProdukt.toLowerCase()" [matTooltip]="row.partnerServiceProdukt | titlecase"></mat-icon>
                    </div>
                  }
                  @if (row.partnerServiceProdukt.toLowerCase() == 'gasstorbraender') {
                    <div>
                      <mat-icon svgIcon="gas"></mat-icon>
                      <span>Gas Storbrænder</span>
                    </div>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="postnummer">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Postnummer</th>
                <td mat-cell *matCellDef="let row">
                  {{ row.postnummer }}
                </td>
              </ng-container>
              <ng-container matColumnDef="fejlet">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Fejlet d.</th>
                <td mat-cell *matCellDef="let row">
                  {{ row.fejlet | date }}
                </td>
              </ng-container>
              <ng-container matColumnDef="fejl">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Fejl</th>
                <td mat-cell *matCellDef="let row">
                  <i class="red">{{ row.fejl }}</i>
                </td>
              </ng-container>
              <ng-container matColumnDef="partnerName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Seneste Partner</th>
                <td mat-cell *matCellDef="let row">
                  {{ row.partnerName }}
                </td>
              </ng-container>
              <ng-container matColumnDef="check">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-checkbox [checked]="hasCheckedItems" (change)="onCheckChange($event, null)"></mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                  <mat-checkbox [checked]="isChecked(row.id)" (change)="onCheckChange($event, row.id)"></mat-checkbox>
                </td>
              </ng-container>
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let row" class="align-right">
                  <button mat-raised-button class="btn-white" (click)="onRowClick(row)" [disabled]="isChecked(row.id)">{{ rowButton }}</button>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row class="cursor-pointer" (dblclick)="openPage(row)" *matRowDef="let row; columns: displayedColumns; index as i"></tr>
            </table>
          </div>
        }
        @if (currentFejlDashboardType != 'PostnummerUdenPartner') {
          <div>
            <table mat-table matSort [dataSource]="dataSource" (matSortChange)="sortData($event)" class="mat-elevation-z0">
              <ng-container matColumnDef="produkt">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
                <td mat-cell *matCellDef="let row">
                  <mat-icon [svgIcon]="row.produkt.toLowerCase()" [matTooltip]="row.produkt | titlecase"></mat-icon>
                </td>
              </ng-container>
              <ng-container matColumnDef="serviceordreNr">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Ordrenr.</th>
                <td mat-cell *matCellDef="let row">
                  @if (row.serviceordreNr) {
                    <div>{{ row.serviceordreNr }}</div>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="okKundeNr">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Kundenr.</th>
                <td mat-cell *matCellDef="let row">
                  {{ row.okKundeNr }}
                </td>
              </ng-container>
              <ng-container matColumnDef="okKundeAftaleNr">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Aftalenr.</th>
                <td mat-cell *matCellDef="let row">
                  {{ row.okKundeAftaleNr }}
                </td>
              </ng-container>
              <ng-container matColumnDef="fejlet">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Fejlet d.</th>
                <td mat-cell *matCellDef="let row">
                  {{ row.fejlet | date }}
                </td>
              </ng-container>
              <ng-container matColumnDef="fejl">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Fejl</th>
                <td mat-cell *matCellDef="let row">
                  <i class="red">{{ row.fejl }}</i>
                </td>
              </ng-container>
              <ng-container matColumnDef="okKundeAnlaegAdresse">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Anlægsadresse</th>
                <td mat-cell *matCellDef="let row">
                  {{ row.okKundeAnlaegAdresse }}
                </td>
              </ng-container>
              <ng-container matColumnDef="partnerName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Partner</th>
                <td mat-cell *matCellDef="let row">
                  {{ row.partnerName }}
                </td>
              </ng-container>
              <ng-container matColumnDef="beloeb">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Beløb</th>
                <td mat-cell *matCellDef="let row">
                  @if (row.kundesegment.toLowerCase() == 'privat') {
                    <div>{{ row.amountInclVat | dkCurrency }} inkl. moms</div>
                  }
                  @if (row.kundesegment.toLowerCase() == 'erhverv') {
                    <div>{{ row.amountExclVat | dkCurrency }} ekskl. moms</div>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="scope">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Kunde/partner</th>
                <td mat-cell *matCellDef="let row">
                  @if (row.opkraevningScope.toLowerCase() == 'customer') {
                    <div>Kunde</div>
                  }
                  @if (row.opkraevningScope.toLowerCase() == 'partner') {
                    <div>Partner</div>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="slutDato">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Opsagt d.</th>
                <td mat-cell *matCellDef="let row">
                  {{ row.terminationDate | date }}
                </td>
              </ng-container>
              <ng-container matColumnDef="check">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-checkbox [checked]="hasCheckedItems" (change)="onCheckChange($event, null)"></mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                  <mat-checkbox [checked]="isChecked(row.id)" (change)="onCheckChange($event, row.id)"></mat-checkbox>
                </td>
              </ng-container>
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let row" class="align-right">
                  <button mat-raised-button class="btn-white" (click)="onRowClick(row)" [disabled]="isChecked(row.id)">{{ rowButton }}</button>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row class="cursor-pointer" (dblclick)="openPage(row)" *matRowDef="let row; columns: displayedColumns; index as i"></tr>
            </table>
          </div>
        }
      </div>
    }
  </div>
}
@if (hasCheckedItems) {
  <div class="save-changes-bar">
    <button mat-raised-button color="primary" (click)="retFlereFejl()">{{ button }}</button>
  </div>
}
